import { ExpandMore } from '@material-ui/icons';
import { formatBRL, formatDateBR, formatDocument } from 'helpers/format';
import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import NewTable from '.';

function extractData(data={}, path=""){
  try {
    let [first,...list] = path.split(".");
    if(list.length>0){
      return extractData(data[first],list.join("."))
    } else {
      return data[first];
    }
  } catch (error) {
    return null;
  }
}

function formatData(data, format){
  switch(format){
    case "money":
      return formatBRL(data)
    case "date":
      return formatDateBR(data)
    case "document":
      return formatDocument(data)
    default:
      return data
  }
}

function treatment(data){
  if(!data){
    if(data === 0) return data;
    return "---"
  } 
  return data;
}

export default function({
  columns=[],
  data=[],
  isLoading,
  dataToExport,
  expandRow=null,
  expandRowColumns=null
}){

  if(isLoading) return (
    <tbody>
      <tr>
        <td colSpan={columns.length + (!!expandRow?1:0)}><Spinner animation="border"/></td>
      </tr>
    </tbody>
  )

  if(data.length === 0) return (
    <tbody>
      <tr>
        <td colSpan={columns.length + (!!expandRow?1:0)}>Sem dados para mostrar</td>
      </tr>
    </tbody>
  )

  const [indexExpand, setIndexExpand] = useState(-1);

  return (
    <tbody>
      {data.map((d,key_d)=>{
        return (
          <React.Fragment key={key_d}>
            <tr>
              {!!expandRow?<td>
                <div style={{cursor: "pointer", transition:".3s", ...(indexExpand==key_d?{transform: "rotate(-90deg)"}:{})}} onClick={()=>{
                  if(indexExpand==key_d){
                    setIndexExpand(-1);
                  } else {
                    setIndexExpand(key_d);
                  }
                }}>
                  <ExpandMore/>
                </div>
              </td>:<></>}
              {columns.map((col, key)=>{
                return (
                  <td key={key} style={col.style} className={col.format}>{
                    dataToExport?
                    extractData(d,col.dataField)
                    :
                    treatment(formatData(extractData(d,col.dataField),col.format))
                  }</td>
                );
              })}
            </tr>
            {!!expandRow?<tr className="expand-row">
              <td colSpan={columns.length + 1} className="expand-row-col">
                <div className={"div-expand-row "+(indexExpand == key_d?"expanded":"")}>
                  <NewTable
                    data={d.expand_row}
                    columns={expandRowColumns}
                    onlyTable
                  />
                </div>
              </td>
            </tr>:<></>}
          </React.Fragment>
        )
      })}
    </tbody>
  );
}